import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { TransactionsModel } from '../models/TransactionsModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class TransactionsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getTransactions(trtype:string, trserial: string,compcode : string) {

      let params = new HttpParams();
        params = params.append("TrType", trtype);
        params = params.append("TrSerial", trserial);
        params = params.append("CompCode", compcode);
        const options = {
          params: params
      };
      return this.http.get<TransactionsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/GetTransactions',options);
    }

    public getTransactionsVisit(trcln_supp:string, trdate: string,compcode : string) {

      let params = new HttpParams();
        params = params.append("TrCln_Supp", trcln_supp);
        params = params.append("TrDate", trdate);
        params = params.append("CompCode", compcode);
        const options = {
          params: params
      };
      return this.http.get<TransactionsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/GetTransactionsVisit',options);
    }
    public AddTransactions(protocolHD: TransactionsModel) {
      return this.http.post<TransactionsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/AddTransactions', protocolHD);
  }
  public delTransactions(trtype:string, trserial: string,compcode : string) {

    let params = new HttpParams();
    params = params.append("TrType", trtype);
    params = params.append("TrSerial", trserial);
    params = params.append("CompCode", compcode);
      const options = {
        params: params
    };
    return this.http.get<TransactionsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/DeleteTransactions',options);
  }

  public getTransactionsLookup(trtype: string, trserial: string, supname: string,compcode: string ) {
    let params = new HttpParams();
    params = params.append("TrType", trtype);
    params = params.append("TrSerial", trserial);
    params = params.append("SupName", supname);
    params = params.append("CompCode", compcode);

    const options = {
        params: params
    };
    return this.http.get<TransactionsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/TransactionsLookup', options);
}
public getTransactionsRevLookup(trtype: string, trserial: string, supname: string,compcode: string ) {
  let params = new HttpParams();
  params = params.append("TrType", trtype);
  params = params.append("TrSerial", trserial);
  params = params.append("SupName", supname);
  params = params.append("CompCode", compcode);

  const options = {
      params: params
  };
  return this.http.get<TransactionsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/TransactionsRevLookup', options);
}
public getTransactionsLookupTop(trtype : string ,compcode: string ) {
  let params = new HttpParams();
  params = params.append("TrType", trtype);
  params = params.append("compCode", compcode);

  const options = {
      params: params
  };
  return this.http.get<TransactionsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/TransactionsLookupTop', options);
}

public getTransactionsRevLookupTop(trtype : string ,compcode: string ) {
  let params = new HttpParams();
  params = params.append("TrType", trtype);
  params = params.append("compCode", compcode);

  const options = {
      params: params
  };
  return this.http.get<TransactionsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/TransactionsRevLookupTop', options);
}

public getSerialTransactions(trtype :string ,compCode: string) {
  let params = new HttpParams();
  params = params.append("TrType", trtype);
    params = params.append("compCode", compCode);
    const options = {
      params: params
  };
  return this.http.get<TransactionsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Transactions/GetTransactionsSerial',options);
 }
}
